import {HorizontalLine} from '@gongxigames/framework/core/fragments/react';
import React from 'react';

export function HorizontalSeparator({width, hidden}: any): JSX.Element | null {
    if (hidden) {
        return null;
    }

    return <HorizontalLine color={0x808080} size={5} width={width} />;
}
